import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ChangeEmailProcedureState } from './ChangeEmailProcedure.state';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Input } from 'src/domains/players/webview/components/form/input/Input';
import { UpdateButton } from 'src/domains/players/webview/components/Account/personalDetailsTab/PersonalDetailsTab.style';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { UsersState } from 'src/domains/players/state/UsersState';

export const ChangeEmailProcedure = observer('ChangeEmailProcedure', () => {
    const common = useCommon();
    const usersState = UsersState.get(common);
    const configState = ConfigComponents.get(common).config;
    const languagesState = LanguagesState.get(common);

    const [state] = React.useState(() => new ChangeEmailProcedureState(usersState, common.trpcClient));

    const { accountSectionVariant } = configState.componentVariants;

    return (
        <form>
            <Input
                name='email-old'
                label={
                    <I18n
                        langKey='account.email-procedure.old-email.label'
                        defaultText='E-mail address'
                    />
                }
                placeholder={languagesState.getTranslation(
                    'account.email-procedure.old-email.placeholder',
                    '*Old e-mail address'
                )}
                state={state.oldEmailState}
                colorTheme='light'
                dataTest='old-email-input'
                autocomplete='new-password'
                errorMarginTop={accountSectionVariant === DefaultComponentVariantType.SECONDARY ? '4px' : undefined}
            />
            <Input
                name='email-new'
                label={
                    <I18n
                        langKey='account.email-procedure.new-email.label'
                        defaultText='*New e-mail address'
                    />
                }
                placeholder={languagesState.getTranslation(
                    'account.email-procedure.new-email.placeholder',
                    '*New e-mail address'
                )}
                state={state.newEmailState}
                colorTheme='light'
                dataTest='new-email-input'
                autocomplete='new-password'
                errorMarginTop={accountSectionVariant === DefaultComponentVariantType.SECONDARY ? '4px' : undefined}
            />
            <Input
                name='email-confirm'
                label={
                    <I18n
                        langKey='account.email-procedure.confirm-email.label'
                        defaultText='*Confirm new e-mail address'
                    />
                }
                placeholder={languagesState.getTranslation(
                    'account.email-procedure.confirm-email.placeholder',
                    '*Confirm new e-mail address'
                )}
                state={state.confirmEmailState}
                colorTheme='light'
                dataTest='confirm-email-input'
                autocomplete='new-password'
                errorMarginTop={accountSectionVariant === DefaultComponentVariantType.SECONDARY ? '4px' : undefined}
            />

            {state.setNewEmailErrorMessage === null ? null : (
                <Messages
                    type='error'
                    marginBottom='8px'
                    message={state.setNewEmailErrorMessage}
                />
            )}

            {state.newEmailAlreadyExistsErrorMessage === null ? null : (
                <Messages
                    type='error'
                    marginBottom='8px'
                    message={state.newEmailAlreadyExistsErrorMessage}
                />
            )}

            {state.isShowSuccessMessage ? (
                <Messages
                    type='success'
                    marginTop='8px'
                    message={
                        <I18n
                            langKey='account.update-email.success-message'
                            defaultText='You have successfully changed your e-mail address.'
                        />
                    }
                />
            ) : null}

            <UpdateButton
                type='button'
                size='large'
                onClick={state.update}
                dataTest='update-email-button'
                disabled={state.isButtonDisabled}
            >
                <I18n
                    langKey='account.email-procedure.submit.label'
                    defaultText='Update Email'
                />
            </UpdateButton>
        </form>
    );
});
